var React = require('react');

function Calendarw (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"iwh","fill":"#fff","d":"M5.2,0.1c-0.8,0-1.4,0.7-1.4,1.4v1H1c-0.5,0-1,0.4-1,1v15.4c0,0.5,0.4,1,1,1H19c0.5,0,1-0.4,1-1V3.5     c0-0.5-0.4-1-1-1h-2.9v-1c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.7-1.4,1.4v1H6.7v-1C6.7,0.8,6,0.1,5.2,0.1L5.2,0.1z M5.2,1.1     c0.3,0,0.5,0.2,0.5,0.5v2.9c0,0.3-0.2,0.5-0.5,0.5S4.8,4.7,4.8,4.5V1.6C4.8,1.3,5,1.1,5.2,1.1L5.2,1.1z M14.8,1.1     c0.3,0,0.5,0.2,0.5,0.5v2.9c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V1.6C14.3,1.3,14.5,1.1,14.8,1.1L14.8,1.1z M1,3.5h2.9v1     c0,0.8,0.6,1.4,1.4,1.4s1.4-0.7,1.4-1.4v-1h6.7v1c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4v-1H19v3.4H1V3.5L1,3.5z M1,7.8H19     v11.1H1V7.8L1,7.8z"}));
}

Calendarw.defaultProps = {"viewBox":"0 0 20 20","width":"20px","height":"20px","id":"calendarw"};

module.exports = Calendarw;

Calendarw.default = Calendarw;
